import { MigrationProcessingDataEntity } from './migration-processing-data-entity';
import { MigrationProcessingRoute } from './migration-processing-route';

export class ParseMetadataResult {
  dataEntities?: MigrationProcessingDataEntity[];
  routes?: MigrationProcessingRoute[];
  validationWarnings?: string[];
  validationErrors?: string[];

  constructor(init?: Partial<ParseMetadataResult>) {
    Object.assign(this, init);
  }
}
